import { render, staticRenderFns } from "./TitleScreen.vue?vue&type=template&id=0f75b6c0&scoped=true&"
import script from "./TitleScreen.vue?vue&type=script&lang=js&"
export * from "./TitleScreen.vue?vue&type=script&lang=js&"
import style0 from "./TitleScreen.vue?vue&type=style&index=0&id=0f75b6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f75b6c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle})
